import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PhoneShell from '../components/shared/PhoneShell';
import { useLang } from '../i18n';
import { useGeo } from '../geo';

const API = process.env.REACT_APP_API_BASE_URL;

const css = `
  .pay-result { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 70vh; padding: 24px; text-align: center; }
  .pay-anim { position: relative; width: 90px; height: 90px; margin-bottom: 24px; }
  .pay-circle { width: 90px; height: 90px; border-radius: 50%; background: rgba(0,210,106,.12); box-shadow: 0 0 0 0 rgba(0,210,106,.3); animation: pulse-ok 1.8s ease infinite; display: grid; place-items: center; }
  @keyframes pulse-ok { 0%,100%{box-shadow:0 0 0 0 rgba(0,210,106,.3)} 50%{box-shadow:0 0 0 18px rgba(0,210,106,0)} }
  .pay-icon { font-size: 40px; }
  .pay-title { font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 8px; }
  .pay-sub { font-size: 14px; color: #9b9ab0; line-height: 1.55; max-width: 260px; }
  .pay-amount { margin: 18px 0; padding: 14px 28px; border-radius: 12px; background: rgba(0,210,106,.1); box-shadow: inset 0 0 0 1px rgba(0,210,106,.25); }
  .pay-amount-val { font-size: 28px; font-weight: 800; color: #00d26a; }
  .pay-amount-label { font-size: 12px; color: #9b9ab0; margin-top: 3px; }
  .pay-actions { display: flex; flex-direction: column; gap: 10px; width: 100%; max-width: 280px; margin-top: 8px; }
  .pay-btn-main { height: 48px; border-radius: 11px; background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; font-size: 15px; font-weight: 700; border: none; font-family: inherit; cursor: pointer; }
  .pay-btn-sec { height: 44px; border-radius: 11px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.1); color: #cfcee0; font-size: 14px; font-weight: 600; border: none; font-family: inherit; cursor: pointer; }
  .pay-order { font-size: 11px; color: #5a5972; margin-top: 16px; }
`;

export default function PaymentSuccess() {
  const { t } = useLang();
  const { symbol, rate } = useGeo().prices;
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const amount   = params.get('AMOUNT') || params.get('summ') || params.get('amount') || null;
  const orderId  = params.get('MERCHANT_ORDER_ID') || params.get('us_id') || null;

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (!stored) return;
    const user = JSON.parse(stored);
    if (!user?.id) return;

    fetch(`${API}/api/user/infos.php?id=${user.id}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          localStorage.setItem('user', JSON.stringify({ ...user, ...data.data }));
          window.dispatchEvent(new Event('userUpdated'));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <PhoneShell activeTab="">
      <style>{css}</style>
      <div className="pay-result">
        <div className="pay-anim">
          <div className="pay-circle">
            <span className="pay-icon">✅</span>
          </div>
        </div>

        <h1 className="pay-title">{t('payment.successTitle')}</h1>
        <p className="pay-sub">{t('payment.successSub')}</p>

        {amount && (
          <div className="pay-amount">
            <div className="pay-amount-val">+{(parseFloat(amount) * rate).toFixed(2)} {symbol}</div>
            <div className="pay-amount-label">{t('payment.credited')}</div>
          </div>
        )}

        <div className="pay-actions">
          <button className="pay-btn-main" onClick={() => navigate('/')}>{t('payment.startBetting')}</button>
          <button className="pay-btn-sec"  onClick={() => navigate('/transactions')}>{t('payment.viewTransactions')}</button>
        </div>

        {orderId && <p className="pay-order">{t('payment.reference', { id: orderId })}</p>}
      </div>
    </PhoneShell>
  );
}
